export default {"src":"/_next/static/media/T.e4432216.svg","height":18,"width":18};